var BTF_SKIP_CHECKOUT_PLUS_WIPE = true;

window.btfOptimisticPending = false;

function btfFormatMoney(cents) {
  if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
    return window.Shopify.formatMoney(cents, window.Shopify.money_format || '${{amount}}');
  }
  var drawer = document.getElementById('byteex_cart_drawer');
  var currency = (drawer && drawer.dataset.currency) || (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'GBP';
  try {
    return (cents / 100).toLocaleString(undefined, { style: 'currency', currency: currency });
  } catch (e) {
    return (cents / 100).toFixed(2);
  }
}

async function btfReadJson(res) {
  if (!res || !res.ok) throw new Error('Cart request failed: ' + (res ? res.status : 'no response'));
  const text = await res.text();
  try {
    return JSON.parse(text);
  } catch (e) {
    throw new Error('Cart request returned non-JSON (' + text.slice(0, 40).replace(/\s+/g, ' ') + '...)');
  }
}

function btfClearLoaders() {
  try { hideSpinnerLoader(); } catch (e) {}
  try { hideSkeleton(); } catch (e) {}
  window.btfOptimisticPending = false;
}

let btfLastCartSig = null;

function btfCartSig(cart) {
  if (!cart || !cart.items) return null;
  return cart.items.map(function (i) { return i.key + ':' + i.quantity; }).join('|') + '#' + cart.total_price;
}

function btfOptimisticQuantity(row, newQty) {
  if (!row) return;

  var input = row.querySelector('.quantity-buttons-container input');
  if (input) input.value = Math.max(0, newQty);

  var unit = parseInt(row.getAttribute('data-unit-price'), 10);
  var priceEl = row.querySelector('.btf-cd__price');
  if (!isNaN(unit) && priceEl && newQty > 0) {
    priceEl.textContent = btfFormatMoney(unit * newQty);
  }

  row.setAttribute('data-quantity', String(Math.max(0, newQty)));
  row.classList.add('is-pending');

  if (newQty <= 0) {
    row.classList.add('is-removing');
  }

  btfOptimisticTotals();
}

function btfOptimisticTotals() {
  var rows = document.querySelectorAll('#byteex_cart_drawer .cart-drawer-product-item[data-line-item-key]');
  var total = 0;
  var count = 0;

  rows.forEach(function (r) {
    if (r.classList.contains('is-removing')) return;
    var qty = parseInt(r.getAttribute('data-quantity'), 10) || 0;
    var unit = parseInt(r.getAttribute('data-unit-price'), 10) || 0;
    total += unit * qty;
    count += qty;
  });

  var subtotal = document.getElementById('drawer_subtotal');
  if (subtotal && rows.length) subtotal.textContent = btfFormatMoney(total);

  var pill = document.querySelector('#byteex_cart_drawer .btf-cd__count');
  if (pill) {
    pill.textContent = String(count);
    pill.style.display = count > 0 ? '' : 'none';
  }

  
  if (count === 0) {
    document.querySelectorAll('#byteex_cart_drawer .btf-cd__row:not([data-line-item-key])').forEach(function (g) {
      g.classList.add('is-removing');
    });
  }
}

function runSpinnerLoader() {
  const spinner_loader = document.querySelector('.spinner-loader');
  if (spinner_loader) {
    spinner_loader.classList.remove('hidden');
    spinner_loader.classList.add('flex');
  }
}

function hideSpinnerLoader() {
  const spinner_loader = document.querySelector('.spinner-loader');
  if (spinner_loader) {
    spinner_loader.classList.add('hidden');
    spinner_loader.classList.remove('flex');
  }
}

function showSkeleton() {
  const skeleton = document.querySelector('.byteex-cart-drawer-items-skeleton');
  const cart_items_container = document.querySelector('.byteex-cart-drawer-items');

  if (skeleton && cart_items_container) {
    skeleton.classList.remove('hidden');
    cart_items_container.classList.add('hidden');
  }
}

function hideSkeleton() {
  const skeleton = document.querySelector('.byteex-cart-drawer-items-skeleton');
  const cart_items_container = document.querySelector('.byteex-cart-drawer-items');

  if (skeleton && cart_items_container) {
    skeleton.classList.add('hidden');
    cart_items_container.classList.remove('hidden');
  }
}

function addCartColorChangeListeners(index, type) {
  const color_picker_modal = document.querySelector(`.picker-modal-${index}`);
  if (!color_picker_modal) return;

  const sorry_label = color_picker_modal.previousElementSibling;
  const selected_colors = color_picker_modal.querySelectorAll('.byteex-cart-selected-color');
  const remove_color_buttons = color_picker_modal.querySelectorAll('.byteex-cart-remove-color');
  const colors_variants = color_picker_modal.querySelectorAll('.byteex-cart-color-item');
  const submit_button = color_picker_modal.querySelector('.byteex-cart-picker-submit');
  const colors_filters = color_picker_modal.querySelectorAll('.byteex-cart-color-filter');

  function filterColors(event) {
    const filter_button = event.currentTarget;
    const filter_value = filter_button.dataset.value;

    colors_filters.forEach((filter) => {
      filter.style.fontWeight = '400';
    });
    filter_button.style.fontWeight = '700';

    colors_variants.forEach((variant) => {
      const variant_filters = variant.dataset.filter.toLowerCase();

      variant.style.display = 'flex';
      if (!variant_filters.includes(filter_value) && filter_value != 'All') {
        variant.style.display = 'none';
      }
    });
  }

  function removeColorHandler(event) {
    const button = event.currentTarget;
    button.style.display = 'none';
    const parent = button.parentElement;
    parent.dataset.empty = 'true';
    parent.dataset.id = 'empty';
    parent.dataset.image = 'empty';
    parent.dataset.color = 'empty';

    const image_element = parent.querySelector('img');
    if (image_element) {
      image_element.style.display = 'none';
    }

    const text_element = parent.nextElementSibling;
    if (text_element) {
      text_element.textContent = '';
    }

    const out_of_stock_label = parent.querySelector('.out-of-stock-label');
    if (out_of_stock_label) {
      out_of_stock_label.style.display = 'none';
    }
  }

  function selectColorHandler(event) {
    const button = event.currentTarget;
    const id = button.dataset.id;
    const image = button.dataset.image;
    const color = button.dataset.color;

    for (const color_variant of selected_colors) {
      const is_empty = color_variant.dataset.empty;

      if (is_empty === 'true') {
        color_variant.dataset.id = id;
        color_variant.dataset.image = image;
        color_variant.dataset.color = color;

        const remove_button = color_variant.querySelector('.byteex-cart-remove-color');
        if (remove_button) {
          remove_button.style.display = 'block';
        }

        const image_element = color_variant.querySelector('img');
        if (image_element) {
          image_element.src = image;
          image_element.style.display = 'block';
        }

        const out_of_stock_label = color_variant.querySelector('.out-of-stock-label');
        if (out_of_stock_label) {
          out_of_stock_label.style.display = 'none';
        }

        const text_element = color_variant.nextElementSibling;
        if (text_element) {
          text_element.textContent = color;
        }

        color_variant.dataset.empty = 'false';
        break;
      }
    }
  }

  async function submitHandler(event) {
    const button = event.currentTarget;
    const key = button.dataset.key;

    let is_all_selected = true;
    let changes = {
      id: key,
      properties: {}
    };

    let index = 1;
    for (const color_variant of selected_colors) {
      const is_empty = color_variant.dataset.empty;

      if (is_empty === 'true') {
        is_all_selected = false;
        break;
      }

      changes.properties[`_id${index}.`] = color_variant.dataset.id;
      changes.properties[`_${index}.`] = color_variant.dataset.image;
      changes.properties[`${type} ${index}`] = color_variant.dataset.color;

      index++;
    }

    if (is_all_selected) {
      const text = button.querySelector('.byteex-cart-picker-submit-text');
      const loader = button.querySelector('.loader');

      if (text) text.style.display = 'none';
      if (loader) loader.style.display = 'block';

      try {
        await fetch(window.Shopify.routes.root + 'cart/change.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(changes),
        });

        colors_filters.forEach((filter) => {
          filter.removeEventListener('click', filterColors);
        });

        remove_color_buttons.forEach((button) => {
          button.removeEventListener('click', removeColorHandler);
        });

        colors_variants.forEach((color_variant) => {
          color_variant.removeEventListener('click', selectColorHandler);
        });

        submit_button.removeEventListener('click', submitHandler);

        await syncCartGifts();
      } catch (error) {
        console.error('Error:', error);
      }
    }
  }

  function sorryLabelCloseHandler(event) {
    const button = event.currentTarget;
    if (button) {
      button.style.display = 'none';
    }
  }

  colors_filters.forEach((filter) => {
    filter.addEventListener('click', filterColors);
  });

  remove_color_buttons.forEach((button) => {
    button.addEventListener('click', removeColorHandler);
  });

  colors_variants.forEach((color_variant) => {
    color_variant.addEventListener('click', selectColorHandler);
  });

  if (submit_button) {
    submit_button.addEventListener('click', submitHandler);
  }

  if (sorry_label) {
    sorry_label.addEventListener('click', sorryLabelCloseHandler);
  }

  const nailPicker = document.querySelector(`.picker-${index}`);
  const overlay = document.querySelector('.cart-overlay');
  if (!overlay) return;

  overlay.addEventListener('click', () => {
    colors_filters.forEach((filter) => {
      filter.removeEventListener('click', filterColors);
    });

    remove_color_buttons.forEach((button) => {
      button.removeEventListener('click', removeColorHandler);
    });

    colors_variants.forEach((color_variant) => {
      color_variant.removeEventListener('click', selectColorHandler);
    });

    if (submit_button) submit_button.removeEventListener('click', submitHandler);
    if (sorry_label) sorry_label.removeEventListener('click', sorryLabelCloseHandler);

    if (nailPicker) nailPicker.style.display = 'none';
    overlay.style.display = 'none';
  });
}

function addCartDrawerListeners() {
  document.querySelectorAll('.quantity-btn').forEach((button) => {
    button.addEventListener('click', async (event) => {
      event.preventDefault();

      const parent = button.closest('.quantity-buttons-wrapper');
      const row = parent.closest('.cart-drawer-product-item');
      const key = row.getAttribute('data-line-item-key');
      const quantityInput = parent.querySelector('input');

      const currentQuantity = quantityInput.value;
      const isUp = button.classList.contains('quantity-plus');
      const newQuantity = isUp ? +currentQuantity + 1 : +currentQuantity - 1;

      
      window.btfOptimisticPending = true;
      btfOptimisticQuantity(row, newQuantity);

      let updates = {
        [key]: newQuantity,
      };

      let cartAfter = null;

      try {
        const response = await fetch(`${window.Shopify.routes.root}cart/update.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ updates }),
        });

        try {
          cartAfter = await btfReadJson(response);
        } catch (readErr) {
          console.error('Cart update failed:', readErr.message);
        }
      } catch (error) {
        console.error('Fetch error:', error);
      } finally {
        try {
          await syncCartGifts(true, cartAfter);
        } finally {
          window.btfOptimisticPending = false;
        }
      }
    });
  });

  document.querySelectorAll('.close_cart_btn').forEach((btn) => {
    btn.addEventListener('click', (event) => {
      event.preventDefault();

      if (typeof cart_upsell_slider !== 'undefined' && cart_upsell_slider) {
        cart_upsell_slider.destroy();
        cart_upsell_slider = null;
      }

      document.documentElement.style.overflow = 'unset';
      const drawer = document.getElementById('byteex_cart_drawer');
      if (drawer) drawer.style.display = 'none';
    });
  });

  const checkout_button = document.getElementById('checkout_btn');
  if (checkout_button) {
    checkout_button.addEventListener('click', async (event) => {
      event.preventDefault();
      event.stopPropagation();

      const button = event.currentTarget;
      button.style.pointerEvents = 'none';
      button.classList.add('loading');

      
      const selected_colors = document.querySelectorAll('.byteex-cart-selected-color');
      let is_empty = false;
      let empty_index;
      let empty_type;
      selected_colors.forEach((color) => {
        if (color.dataset.empty === 'true') {
          is_empty = true;
          empty_index = color.dataset.index;
          empty_type = color.dataset.type;
        }
      });

      if (is_empty) {
        button.style.pointerEvents = '';
        button.classList.remove('loading');

        const nailPicker = document.querySelector(`.picker-${empty_index}`);
        if (nailPicker) {
          const sorryLabel = nailPicker.querySelector('.sorry-label');
          if (sorryLabel) sorryLabel.style.display = 'block';

          const overlay = document.querySelector('.cart-overlay');
          nailPicker.style.display = 'block';
          if (overlay) overlay.style.display = 'block';

          addCartColorChangeListeners(empty_index, empty_type);
        }
        return;
      }

      try {
        await syncCartGifts(false);
      } catch (error) {
        console.error('Pre-checkout sync failed, proceeding anyway:', error);
      }

      window.location.href = '/checkout';
    });
  }

  const remove_buttons = document.querySelectorAll('.remove-cart-item');
  remove_buttons.forEach((button) => {
    button.addEventListener('click', async (event) => {
      const button = event.currentTarget;
      const id = button.dataset.key;

      const row = button.closest('.cart-drawer-product-item');
      window.btfOptimisticPending = true;
      btfOptimisticQuantity(row, 0);

      let updates = {
        [id]: 0,
      };

      let cartAfter = null;

      try {
        const response = await fetch(`${window.Shopify.routes.root}cart/update.js`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({ updates }),
        });

        try {
          cartAfter = await btfReadJson(response);
        } catch (readErr) {
          console.error('Cart update failed:', readErr.message);
        }
      } catch (error) {
        console.error('Fetch error:', error);
      } finally {
        try {
          await syncCartGifts(true, cartAfter);
        } finally {
          window.btfOptimisticPending = false;
        }
      }
    });
  });

  const remove_gel_set_buttons = document.querySelectorAll('.remove-gel-wrap-set');
  remove_gel_set_buttons.forEach((button) => {
    button.addEventListener('click', async (event) => {
      showSkeleton();
      runSpinnerLoader();

      const boxIndex = event.currentTarget.dataset.key;
      const updates = {};

      try {
        const cart = await btfReadJson(await fetch('/cart.js'));

        (cart.items || []).forEach((item) => {
          const props = item.properties || {};
          const itemBoxKey = props._dynamicBoxIndex || props._bundleId;

          if (itemBoxKey && String(itemBoxKey) === String(boxIndex)) {
            updates[item.key] = 0;
          }
        });

        let cartAfter = null;

        if (Object.keys(updates).length) {
          const res = await fetch(`${window.Shopify.routes.root}cart/update.js`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ updates }),
          });
          try { cartAfter = await btfReadJson(res); } catch (e) {}
        }

        await syncCartGifts(true, cartAfter);
      } catch (err) {
        console.error('Error removing box:', err);
      } finally {
        btfClearLoaders();
      }
    });
  });

  const pedicure_colors_picker_open_button = document.querySelector('.pedicure-colors-picker-open-button');
  const pedicure_colors_picker = document.querySelector('.pedicure-colors-picker');
  let pedicure_colors_array = [];
  if (pedicure_colors_picker_open_button) {
    pedicure_colors_picker_open_button.addEventListener('click', () => {
      pedicure_colors_picker.classList.remove('hidden');

      (function () {
        const el = document.querySelector('.pedicure-color-list-slider-wrapper');
        if (!el) return;

        const bar = document.querySelector('.pedicure-color-list-scrollbar');
        if (!bar) return;

        const track = bar.querySelector('.track');
        const thumb = bar.querySelector('.thumb');

        let isDown = false;
        let startX = 0;
        let startScrollLeft = 0;

        let velocity = 0;
        let lastX = 0;
        let lastTime = 0;
        let rafId = 0;

        const stopMomentum = () => {
          cancelAnimationFrame(rafId);
        };

        const momentum = () => {
          if (Math.abs(velocity) < 0.01) return;
          el.scrollLeft -= velocity * 12;
          velocity *= 0.95;

          updateThumb();
          rafId = requestAnimationFrame(momentum);
        };

        el.addEventListener('dragstart', (e) => e.preventDefault());

        el.addEventListener('mousedown', (e) => {
          if (e.button !== 0) return;
          isDown = true;
          el.classList.add('grabbing');
          bar.classList.add('active');

          startX = e.clientX;
          startScrollLeft = el.scrollLeft;
          velocity = 0;
          lastX = e.clientX;
          lastTime = Date.now();
          stopMomentum();
        });

        window.addEventListener(
          'mousemove',
          (e) => {
            if (!isDown) return;
            e.preventDefault();
            const dx = e.clientX - startX;
            el.scrollLeft = startScrollLeft - dx;

            const now = Date.now();
            const dt = now - lastTime;
            if (dt > 0) velocity = (e.clientX - lastX) / dt;
            lastX = e.clientX;
            lastTime = now;

            updateThumb();
          },
          { passive: false }
        );

        const endDrag = () => {
          if (!isDown) return;
          isDown = false;
          el.classList.remove('grabbing');

          setTimeout(() => bar.classList.remove('active'), 120);

          if (Math.abs(velocity) > 0.08) momentum();
        };

        window.addEventListener('mouseup', endDrag);
        el.addEventListener('mouseleave', endDrag);

        function updateThumb() {
          const cw = el.clientWidth;
          const sw = el.scrollWidth;
          const sl = el.scrollLeft;

          if (sw <= cw) {
            thumb.style.width = '0px';
            thumb.style.transform = 'translateX(0)';
            return;
          }

          const trackW = track.clientWidth;
          const minThumb = 40;
          const thumbW = Math.max((cw / sw) * trackW, minThumb);
          const maxLeft = trackW - thumbW;
          const left = (sl / (sw - cw)) * maxLeft;

          thumb.style.width = thumbW + 'px';
          thumb.style.transform = `translateX(${left}px)`;
        }

        function syncBarWidth() {
          updateThumb();
        }

        el.addEventListener('scroll', updateThumb, { passive: true });
        window.addEventListener('resize', syncBarWidth);

        if (typeof ResizeObserver !== 'undefined') {
          const ro = new ResizeObserver(() => syncBarWidth());
          ro.observe(el);
          ro.observe(track);
        } else {
          setTimeout(syncBarWidth, 60);
        }

        syncBarWidth();
        setTimeout(syncBarWidth, 250);
      })();
    });
  }

  function getPedicureColorItemCount(targetId) {
    return pedicure_colors_array.filter((id) => id === targetId).length;
  }

  const pedicure_colors_picker_submit_button = document.querySelector('.pedicure-colors-picker-submit-button');

  document.querySelectorAll('.add-pedicure-color-item').forEach((button) => {
    button.addEventListener('click', (event) => {
      const id = event.currentTarget.dataset.id;

      pedicure_colors_array.push(id);

      const current_quantity_wrapper = document.querySelector(`.quantity-pedicure-color-item-wrapper[data-id="${id}"]`);
      if (current_quantity_wrapper) {
        current_quantity_wrapper.classList.remove('hidden');
        current_quantity_wrapper.querySelector('.pedicure-color-item-count').textContent = getPedicureColorItemCount(id);
      }

      const current_image_wrapper = document.querySelector(`.pedicure-picker-color-image-wrapper[data-id="${id}"]`);
      if (current_image_wrapper) {
        current_image_wrapper.classList.add('selected-pedicure-color-item');
      }

      pedicure_colors_picker_submit_button.textContent = pedicure_colors_picker_submit_button.dataset.addText;
      pedicure_colors_picker_submit_button.removeAttribute('disabled');
    });
  });

  document.querySelectorAll('.plus-pedicure-color-item').forEach((button) => {
    button.addEventListener('click', (event) => {
      const id = event.currentTarget.dataset.id;

      pedicure_colors_array.push(id);

      const current_quantity_wrapper = document.querySelector(`.quantity-pedicure-color-item-wrapper[data-id="${id}"]`);
      if (current_quantity_wrapper) {
        current_quantity_wrapper.querySelector('.pedicure-color-item-count').textContent = getPedicureColorItemCount(id);
      }
    });
  });

  document.querySelectorAll('.minus-pedicure-color-item').forEach((button) => {
    button.addEventListener('click', (event) => {
      const id = event.currentTarget.dataset.id;

      const index = pedicure_colors_array.indexOf(id);
      if (index !== -1) {
        pedicure_colors_array.splice(index, 1);
      }

      const count = getPedicureColorItemCount(id);
      const current_quantity_wrapper = document.querySelector(`.quantity-pedicure-color-item-wrapper[data-id="${id}"]`);

      if (count <= 0) {
        current_quantity_wrapper.classList.add('hidden');
        current_quantity_wrapper.querySelector('.pedicure-color-item-count').textContent = 0;

        const current_image_wrapper = document.querySelector(`.pedicure-picker-color-image-wrapper[data-id="${id}"]`);
        if (current_image_wrapper) {
          current_image_wrapper.classList.remove('selected-pedicure-color-item');
        }
      } else {
        current_quantity_wrapper.querySelector('.pedicure-color-item-count').textContent = count;
      }

      if (pedicure_colors_array.length === 0) {
        pedicure_colors_picker_submit_button.textContent = pedicure_colors_picker_submit_button.dataset.chooseText;
        pedicure_colors_picker_submit_button.disabled = true;
      }
    });
  });

  if (pedicure_colors_picker_submit_button) {
    pedicure_colors_picker_submit_button.addEventListener('click', async () => {
      if (pedicure_colors_array.length > 0) {
        runSpinnerLoader();

        const formData = {
          items: pedicure_colors_array.map((id) => ({ id: id, quantity: 1 })),
        };

        let cartAfter = null;

        try {
          const res = await fetch(window.Shopify.routes.root + 'cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(formData),
          });
          if (res.ok) await res.json();
        } catch (error) {
          console.error('Error:', error);
        }

        await syncCartGifts(true, cartAfter);
      }

      pedicure_colors_picker.classList.add('hidden');
    });
  }

  document.querySelectorAll('.pedicure-colors-picker-close-button').forEach((button) => {
    button.addEventListener('click', () => {
      pedicure_colors_picker.classList.add('hidden');
    });
  });

  const cart_drawer_root = document.getElementById('byteex_cart_drawer');
  const cart_upsell_atc_buttons = cart_drawer_root ? cart_drawer_root.querySelectorAll('.cart-upsell-atc-button') : [];
  cart_upsell_atc_buttons.forEach((button) => {
    button.addEventListener('click', async (event) => {
      event.preventDefault();

      showSkeleton();
      runSpinnerLoader();

      const id = event.currentTarget.dataset.id;

      let formData = {
        items: [{ id: id, quantity: 1 }],
      };

      let cartAfter = null;

      try {
        const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(formData),
        });

        if (!response.ok) {
          console.error(`Cart add error: ${response.status}`);
        }
      } catch (error) {
        console.error('Fetch error:', error);
      } finally {
        await syncCartGifts(true, cartAfter);
      }
    });
  });

  document.querySelectorAll('.cart-upsell-choose-colors-button').forEach((button) => {
    button.addEventListener('click', (event) => {
      const choose_colors_element = event.currentTarget.nextElementSibling;
      choose_colors_element.style.display = 'block';

      let colors_array = [];

      choose_colors_element.querySelectorAll('.cart-upsell-color-add').forEach((button) => {
        button.addEventListener('click', (event) => {
          const button = event.currentTarget;
          const id = button.dataset.id;
          const is_added = button.dataset.added;

          if (is_added === 'false') {
            colors_array.push(id);
            button.style.backgroundColor = '#000000';
            button.style.color = '#fff';
            button.querySelector('.cart-upsell-color-add-text').classList.add('hidden');
            button.querySelector('.cart-upsell-color-added-text').classList.remove('hidden');
            button.dataset.added = 'true';
          } else {
            button.style.backgroundColor = '#ffffff';
            button.style.color = '#000000';
            button.querySelector('.cart-upsell-color-add-text').classList.remove('hidden');
            button.querySelector('.cart-upsell-color-added-text').classList.add('hidden');
            button.dataset.added = 'false';
            colors_array = colors_array.filter((color) => color !== id);
          }
        });
      });

      choose_colors_element.querySelectorAll('.cart-upsell-choose-colors-submit-button').forEach((button) => {
        button.addEventListener('click', async (event) => {
          const block_id = event.currentTarget.dataset.blockId;

          if (colors_array.length > 0) {
            runSpinnerLoader();

            const formData = {
              items: colors_array.map((id) => ({ id: id, quantity: 1 })),
            };

            try {
              await fetch(window.Shopify.routes.root + 'cart/add.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(formData),
              });
            } catch (error) {
              console.error('Error:', error);
            }

            await syncCartGifts();
          }

          choose_colors_element.style.display = 'none';
          const block_element = document.querySelector(`.${block_id}`);
          if (block_element) block_element.style.display = 'none';
        });
      });
    });
  });

  document.querySelectorAll('.open-color-change').forEach((button) => {
    button.addEventListener('click', (event) => {
      const index = event.currentTarget.dataset.index;
      const type = event.currentTarget.dataset.type;

      const nailPicker = document.querySelector(`.picker-${index}`);
      const overlay = document.querySelector('.cart-overlay');
      if (nailPicker) nailPicker.style.display = 'block';
      if (overlay) overlay.style.display = 'block';

      addCartColorChangeListeners(index, type);
    });
  });
}

function resetDrawerUi() {
  hideSpinnerLoader();
  hideSkeleton();

  const drawer = document.getElementById('byteex_cart_drawer');
  if (drawer) drawer.style.display = 'none';

  document.documentElement.style.overflow = 'unset';
}

window.addEventListener('pageshow', (event) => {
  resetDrawerUi();
  updateCartItemCount();
  if (event.persisted) btfLastCartSig = null;
});

async function updateCartItemCount(cart) {
  if (!cart) {
    try {
      cart = await btfReadJson(await fetch('/cart.js'));
    } catch (error) {
      return;
    }
  }

  const items = (cart && cart.items) || [];

  const count = items.reduce((sum, item) => {
    if (item.price === 0 || item.title.includes('Checkout')) {
      return sum;
    }
    return sum + item.quantity;
  }, 0);

  const items_count_element = document.querySelector('.cart_items_counter');

  if (items_count_element) {
    const items_count_element_wrapper = items_count_element.parentElement;

    if (count > 0) {
      items_count_element_wrapper.classList.remove('hidden');
      items_count_element_wrapper.classList.add('flex');
      items_count_element.textContent = count;
    } else {
      items_count_element_wrapper.classList.add('hidden');
      items_count_element_wrapper.classList.remove('flex');
    }
  }
}

async function fetchCartDrawerMarkup() {
  const locale = Shopify?.locale;
  const localePrefix = locale && locale !== 'en' ? `/${locale}` : '';

  const drawerEl = document.querySelector('.byteex_cart_drawer');
  const sectionId = (drawerEl && drawerEl.dataset.sectionId) || '';

  const parse = async (url) => {
    const res = await fetch(url);
    if (!res.ok) throw new Error(`Cart loading error: ${res.status}`);

    const html = document.createElement('div');
    html.innerHTML = await res.text();

    return html.querySelector('.byteex_cart_drawer');
  };

  if (sectionId) {
    try {
      const markup = await parse(`${localePrefix}/?section_id=${encodeURIComponent(sectionId)}`);
      if (markup) return markup;
    } catch (error) {
      console.warn('Section render failed, falling back to a full page render:', error);
    }
  }

  return parse(`${localePrefix}/`);
}

let cartSyncInFlight = null;
let cartSyncRepeat = false;

async function syncCartGifts(render, knownCart) {
  if (cartSyncInFlight) {
    cartSyncRepeat = true;
    return cartSyncInFlight;
  }

  cartSyncInFlight = (async () => {
    let markup = null;
    let cart = knownCart || null;

    do {
      cartSyncRepeat = false;

      try {
        markup = await fetchCartDrawerMarkup();
      } catch (error) {
        console.error('Error fetching cart drawer markup:', error);
      }

      let result = { changed: false, cart: cart };
      try {
        result = await window.reconcileGifts(markup, cart);
      } catch (error) {
        console.error('Error reconciling gifts:', error);
      }

      cart = (result && result.cart) || null;
    } while (cartSyncRepeat);

    if (render === false) return;

    if (!markup) {
      btfClearLoaders();
      return;
    }

    await updateCartDrawer(markup);
    await updateCartItemCount(cart);
    btfLastCartSig = btfCartSig(cart);
  })();

  try {
    await cartSyncInFlight;
  } catch (error) {
    console.error('Cart sync failed:', error);
    btfClearLoaders();
  } finally {
    cartSyncInFlight = null;
    btfClearLoaders();
  }
}

let drawerRenderInFlight = null;

async function updateCartDrawer(prefetchedMarkup) {
  if (drawerRenderInFlight) {
    await drawerRenderInFlight;
  }

  drawerRenderInFlight = (async () => {
    if (typeof cart_upsell_slider !== 'undefined' && cart_upsell_slider) {
      cart_upsell_slider.destroy();
      cart_upsell_slider = null;
    }

    try {
      showSkeleton();
      runSpinnerLoader();

      const newContentEl = prefetchedMarkup || (await fetchCartDrawerMarkup());
      const currentDrawer = document.querySelector('.byteex_cart_drawer');

      if (newContentEl && currentDrawer) {
        currentDrawer.innerHTML = newContentEl.innerHTML;
        addCartDrawerListeners();
      } else {
        console.warn('Could not find .byteex_cart_drawer in the new or current HTML');
      }
    } catch (error) {
      console.error('Error in updateCartDrawer:', error);
    } finally {
      hideSpinnerLoader();

      const slider_container = document.getElementById('keen-upsell-slider');
      if (slider_container && typeof KeenSlider !== 'undefined') {
        cart_upsell_slider = new KeenSlider(
          '#keen-upsell-slider',
          {
            loop: false,
            slides: {
              spacing: 1,
              perView: 1,
            },
          },
          [cart_upsell_navigation]
        );
      }

      hideSkeleton();

      document.querySelectorAll('.cart-drawer-product-title').forEach((title) => {
        const title_text = title.querySelector('p');
        const title_blur = title.querySelector('div');
        if (!title_text || !title_blur) return;

        if (title_text.offsetHeight > 42) {
          title_blur.classList.remove('hidden');
        }
      });

      document.querySelectorAll('.cart-drawer-upsell-product-title').forEach((title) => {
        const title_text = title.querySelector('p');
        const title_blur = title.querySelector('div');
        if (!title_text || !title_blur) return;

        if (title_text.offsetHeight > 21) {
          title_blur.classList.remove('hidden');
        }
      });
    }
  })();

  try {
    await drawerRenderInFlight;
  } finally {
    drawerRenderInFlight = null;
  }
}

function addToCartFormListeners() {
  const addToCartForms = document.querySelectorAll('form[action*="/cart/add"]');
  addToCartForms.forEach((form) => {
    form.removeEventListener('submit', handleAddToCartSubmit);
    form.addEventListener('submit', handleAddToCartSubmit);
  });
}

async function handleAddToCartSubmit(event) {
  showSkeleton();
  runSpinnerLoader();

  event.preventDefault();
  const form = event.currentTarget;
  const productType = form.dataset.productType;

  const loader = form.querySelector('.loader');
  const buttonText = form.querySelector('.atc_button_text');
  const priceAtc = form.querySelector('.price-atc');
  const priceAtcArrow = form.querySelector('.price-atc-arrow');
  const atc_button_text = document.getElementById('atc-button-text');

  const stickyLoader = document.getElementById('sticky_atc_button_loader');
  const stickyButtonText = document.getElementById('sticky_atc_button_text');

  if (atc_button_text) atc_button_text.style.display = 'none';
  if (priceAtc) priceAtc.style.display = 'none';
  if (priceAtcArrow) priceAtcArrow.style.display = 'none';
  if (buttonText) buttonText.style.display = 'none';
  if (loader) loader.style.display = 'block';
  if (stickyButtonText) stickyButtonText.style.display = 'none';
  if (stickyLoader) stickyLoader.style.display = 'block';

  const body = new FormData(form);

  try {
    await fetch('/cart/add', {
      method: 'post',
      body: body,
    });

    if (productType === 'at-home-nail-manicure-kit') {
      window.clearNailPicker();
    } else if (productType === 'nail-picker-6-redesing') {
      window.clearNailPicker6Redesign();
    } else if (productType === 'nail-picker-3-redesing') {
      window.clearNailPicker3Redesign();
    } else if (productType === 'nail-picker-updated') {
      window.clearNailPickerUpdated();
    } else if (productType === 'nail-picker-gel-wraps') {
      window.clearNailPickerGelWraps();
    } else if (productType === 'new-nail-picker') {
      window.clearNewNailPicker();
    } else if (productType === 'two-nail-picker-on-page') {
      window.clearTwoNailPickerOnPage();
    } else if (productType === 'default') {
      if (atc_button_text) atc_button_text.style.display = 'flex';
    }

    if (buttonText) buttonText.style.display = 'flex';
    if (priceAtc) priceAtc.style.display = 'flex';
    if (loader) loader.style.display = 'none';
    if (stickyButtonText) stickyButtonText.style.display = 'inline';
    if (stickyLoader) stickyLoader.style.display = 'none';

    syncCartGifts();

    if (
      !form.classList.contains('upsell_form') &&
      !form.classList.contains('addon_form') &&
      !form.classList.contains('pre-cart-form')
    ) {
      onOpenDrawer();
    }
  } catch (error) {
    console.error('Error adding to cart:', error);
  }
}

addToCartFormListeners();

updateCartItemCount();

window.readExpectedGifts = function (root) {
  const el = (root || document).querySelector('.data-cart-gifts-ids');
  const expected = new Map();
  if (!el) return expected;

  String(el.dataset.cartGiftsIds || '')
    .split(',')
    .map((id) => Number(id.trim()))
    .filter((id) => id > 0)
    .forEach((id) => expected.set(id, (expected.get(id) || 0) + 1));

  return expected;
};

window.reconcileGifts = async function (root, knownCart) {
  const target = window.readExpectedGifts(root);

  let cart = knownCart || null;

  if (!cart) {
    try {
      cart = await btfReadJson(await fetch('/cart.js', { cache: 'no-store' }));
    } catch (error) {
      console.warn('reconcileGifts: could not read cart:', error.message);
      return { changed: false, cart: null };
    }
  }

  const items = (cart && cart.items) || [];

  const freeLines = items.filter((item) => item.original_price === 0);
  if (target.size === 0 && freeLines.length === 0) return { changed: false, cart: cart };

  const present = new Map();
  freeLines.forEach((line) => {
    present.set(line.variant_id, (present.get(line.variant_id) || 0) + line.quantity);
  });

  const trims = {};
  freeLines.forEach((line) => {
    const want = target.get(line.variant_id) || 0;
    const have = present.get(line.variant_id) || 0;
    if (have <= want) return;

    const keep = Math.max(0, line.quantity - (have - want));
    if (keep === line.quantity) return;

    trims[line.key] = keep;
    present.set(line.variant_id, have - (line.quantity - keep));
  });

  let changed = false;

  if (Object.keys(trims).length) {
    try {
      const res = await fetch(window.Shopify.routes.root + 'cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ updates: trims }),
      });
      cart = await btfReadJson(res);
      changed = true;
    } catch (error) {
      console.error('Error trimming gifts:', error);
    }
  }

  const missing = [];
  target.forEach((want, variantId) => {
    const have = present.get(variantId) || 0;
    if (want > have) {
      missing.push({
        id: variantId,
        quantity: want - have,
        properties: { _gift: 'true' },
      });
    }
  });

  if (missing.length) {
    try {
      const res = await fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: missing }),
      });
      if (res.ok) cart = null;
      changed = true;
    } catch (error) {
      console.error('Error restoring gifts:', error);
    }
  }

  return { changed: changed, cart: cart };
};

window.refreshCartOnOpen = function () {
  fetch('/cart.js', { cache: 'no-store' })
    .then(btfReadJson)
    .then((cart) => {
      const needsWipe = !BTF_SKIP_CHECKOUT_PLUS_WIPE &&
        (cart.items || []).some((item) => item.title.includes('Checkout'));

      
      if (!needsWipe && btfLastCartSig && btfCartSig(cart) === btfLastCartSig) {
        btfClearLoaders();
        updateCartItemCount(cart);
        return null;
      }

      showSkeleton(true);

      if (!needsWipe) return { cart: cart, mutated: false };

      const updates = {};
      (cart.items || []).forEach((item) => {
        if (item.title.includes('Checkout')) updates[item.key] = 0;
      });

      return fetch(`${window.Shopify.routes.root}cart/update.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ updates }),
      })
        .then(btfReadJson)
        .then((updated) => ({ cart: updated, mutated: true }));
    })
    .then(async (state) => {
      if (!state) return;
      await syncCartGifts(true, state.cart);
    })
    .catch((err) => {
      console.error('Error processing cart:', err);
      btfClearLoaders();
    });
};